module.exports = __webpack_public_path__ + "img/mstile-310x310.453b693a.png";